<template>

        <div class="question-steps">
            <div  v-for="q in q_length" class="step " :class="{finished: (q-1) < currentQuestion, active:(q-1) == currentQuestion}"></div>
        </div>

</template>

<script>
    export default {
        name: 'steps',
        props: [ 'q_length','currentQuestion' ]
    }

</script>


// WEBPACK FOOTER //
// src/components/steps.vue